export enum SurveyStatus {
  Qualifies = 'qualifies',
  NotQualifies = 'not-qualifies',
  WaitingForApprov = 'waiting-for-approv',
}
